"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const initAssignment_1 = __importDefault(require("./actions/initAssignment"));
const removeAssignment_1 = __importDefault(require("./actions/removeAssignment"));
const setActiveAssignment_1 = __importDefault(require("./actions/setActiveAssignment"));
const toggleAssignment_1 = __importDefault(require("./actions/toggleAssignment"));
function assignmentReducer(state, action) {
    switch (action.type) {
        case 'INITIATE_ASSIGNMENTS': {
            return (0, initAssignment_1.default)(action);
        }
        case 'REMOVE': {
            const { axis, ids, atomID } = action.payload;
            return (0, removeAssignment_1.default)(state, { axis, ids, atomID });
        }
        case 'TOGGLE': {
            return (0, toggleAssignment_1.default)(state, action);
        }
        case 'SET_ACTIVE': {
            return (0, setActiveAssignment_1.default)(state, action);
        }
        case 'SHOW': {
            const { id, axis } = action.payload;
            return {
                ...state,
                highlighted: {
                    id,
                    axis: axis || null,
                },
            };
        }
        case 'HIDE': {
            return {
                ...state,
                highlighted: null,
            };
        }
        default:
            return state;
    }
}
exports.default = assignmentReducer;
